/** Type Utils */

import { SetStateAction } from 'react';

export type Mutable<T> = {
  -readonly [P in keyof T]: T[P];
};

export type DeepMutable<T> = {
  -readonly [P in keyof T]: T[P] extends object ? DeepMutable<T[P]> : T[P];
};

export type Diff<A, B> = A extends B ? never : A;

/**
 * help typescript remove the static-value type of setterOrUpdater
 * so we can call `setterOrUpdater` as a function
 */
export function isFunctionSetter<S>(
  setterOrUpdater: SetStateAction<S>
): setterOrUpdater is (prevState: S) => S {
  return typeof setterOrUpdater === 'function';
}
